import "./usernav.css"
import React, { useState, useEffect } from "react";
import axios from "axios";
import { User, MapPin, Heart, LogOut, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IoPerson } from "react-icons/io5";
import { MdOutlineMenuOpen } from "react-icons/md";
import { IoClose } from "react-icons/io5";
const Usernav = () => {
  const navigate = useNavigate()
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("role");
    alert("You have logged out successfully.");
    navigate("/login");
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);


  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mob_number: localStorage.getItem("phoneNumber"),
    dob: "",
    password: "",
  });
  const phoneNumber = localStorage.getItem("phoneNumber");


  // Fetch user data if phoneNumber exists
  useEffect(() => {
    const fetchUser = async () => {
      if (!phoneNumber) {

        return;
      }
      try {
        const response = await axios.get(
          `/api/profile?phone=${phoneNumber}`
        );
        if (response.data) {
          setUser(response.data);

        }
      } catch (error) {
        console.error("Error fetching user", error);

      }
    };
    fetchUser();
  }, [phoneNumber]);

  return (
    <>
      <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
        <MdOutlineMenuOpen />
      </button>
      <div
        className={`user-sidebar ${isSidebarOpen ? 'mobile-visible' : 'mobile-hidden'
          }`}
      >
        <div className="navcontiner ">
          <button onClick={toggleSidebar} className='closebutton'>
            <IoClose size={28} />
          </button>
          <div className="dashboard">
            <ul><IoPerson size={100} />
              <li>{user.firstname}</li>
              <li className="navitem"><User /> <Link to='/userprofile' style={{ color: "black" }}>Profile</Link> </li>
              <li className="navitem"><ShoppingBag /><Link to='/userorder' style={{ color: "black" }}>Your Orders</Link> </li>
              <li className="navitem"><MapPin /><Link to='/Address' style={{ color: "black" }}>My Address</Link> </li>
              {/* <li className="navitem"><Heart /> Wishlist</li> */}
              <li className="navitem">
                <LogOut />
                <Link to="/login" onClick={handleLogout} style={{ color: "black" }}>
                  Logout
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default Usernav;